import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import "./table.css";
import $dZ3Oa$table_cssmjs from "./table_css.mjs";
import {useTableContext as $2a45525f66468ec9$export$3cb274deb6c2d854} from "./TableViewBase.mjs";
import $dZ3Oa$react, {useRef as $dZ3Oa$useRef} from "react";
import {useVisuallyHidden as $dZ3Oa$useVisuallyHidden} from "react-aria/VisuallyHidden";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 




function $9b909c804a6da52e$export$2c0bab5914a9d088(props) {
    let { dropState: dropState, dragAndDropHooks: dragAndDropHooks } = (0, $2a45525f66468ec9$export$3cb274deb6c2d854)();
    const { target: target, rowProps: rowProps } = props;
    let ref = (0, $dZ3Oa$useRef)(null);
    let { dropIndicatorProps: dropIndicatorProps } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $dZ3Oa$useVisuallyHidden)();
    let isDropTarget = dropState.isDropTarget(target);
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return /*#__PURE__*/ (0, $dZ3Oa$react).createElement("div", {
        style: {
            position: 'absolute',
            top: typeof rowProps.style?.top === 'number' && typeof rowProps.style?.height === 'number' ? rowProps.style.top + (target.dropPosition === 'after' ? rowProps.style.height : 0) : 0,
            width: rowProps.style?.width
        },
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden']
    }, /*#__PURE__*/ (0, $dZ3Oa$react).createElement("div", {
        role: "gridcell",
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dZ3Oa$table_cssmjs))), 'react-spectrum-Table-InsertionIndicator', {
            'react-spectrum-Table-InsertionIndicator--dropTarget': isDropTarget
        })
    }, /*#__PURE__*/ (0, $dZ3Oa$react).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: ref
    })));
}


export {$9b909c804a6da52e$export$2c0bab5914a9d088 as InsertionIndicator};
//# sourceMappingURL=InsertionIndicator.mjs.map
